import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import 'react-multi-email/style.css';
import SubmitButton from './../../components/SubmitButton/index';
import schema from './schema'
import { InfoMessage } from '../../components/Messages/index';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';




const InviteForm = ({
    inactiveMessage = '',
    onSubmit,
    readOnlyOptions = null,
    isUpdateMode,
    onInstructionsChange = () => null,
    additionalFieldsRenderer = () => null,
    addressFieldsRenderer = () => null,
    warningMessage,
    eventName,
    sellerName,
    onValidateControls,
    isEmptySeats,
    sellerEmail=null
}) => {
    const defaultEmailValue = (readOnlyOptions || {}).receiver || '';
    const defaultInstructionsValue = (readOnlyOptions || {}).specialInstructions || '';
    const defaultEventlocationValue = (readOnlyOptions || {}).eventlocation || '';

    const [email, setEmail] = useState(defaultEmailValue);
    const [error, setError] = useState('');
    const [instructions, setInstructions] = useState(defaultInstructionsValue);
    const [eventlocation, setEventlocation] = useState(defaultEventlocationValue);
    var eventLocation = useSelector(state => state.scheduleCreationData.eventLocation);
    const validateEmail = (email) => {
        const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
        return pattern.test(email);

    }

    const handleSubmit = async () => {
        

        var valid = true;
        var emails = email.trim().replace(/\n/g, '').split(";");
        emails = emails.filter(function (e) { return e !== "" });
        if (emails !== undefined && emails !== null && emails.length > 0) {
            //if (emails[0] !== "") {
                emails.map(m => {
                    if (!validateEmail(m)) {
                        valid = false;
                        setError("Invalid email address");
                    }

                });
            if (valid) {
                emails.map(m => {
                    if (m == sellerEmail) {
                        valid = false;
                        setError("Not allowed to enter attendees email same as of seller");
                    }

                });

            }
            //}
            //else {
            //    valid = false;
            //    setError("This field is required")
            //}
        }
        else {
            valid = false;
            setError("This field is required")
        }
        if (sellerName!= null)
            sellerName= sellerName.trim();
        if (sellerName === undefined || sellerName === null || sellerName === "") {
            onValidateControls('hostname', true);
            valid = false;
        }
        else {
            onValidateControls('hostname', false);
        }

        onValidateControls('emptyseats');

        if (isEmptySeats === true) {
            valid = false;
        }

        if (valid) {
            setEmail(emails.join(";"))
            onSubmit({
                email,
                instructions,
                eventlocation
            })
        }
        //schema.validate({ email }, { abortEarly: false })
        //    .then(() => {
        //        onSubmit({
        //            email,
        //            instructions
        //        })
        //    })
        //    .catch((err) => {
        //        debugger;
        //        const error = err.inner.reduce((acc, cur) => ({ ...acc, [cur.path]: cur.errors[0] }), {}).email
        //        setError(error)
        //    })
    }

    const setEmails = (value) => {
        
        var emails = value.trim().replace(/\n/g, '').split(";");
        var objAllEmails = [];
        if (emails !== undefined && emails !== null && emails.length > 0) {
            for (var i = 0; i < emails.length; i++) {
                objAllEmails.push(emails[i].trim())
            }
            
        }

        setEmail(objAllEmails.join(";"))
    }

    const getDisableError = () => {
        return inactiveMessage && inactiveMessage;
    }

    const handleInstructionsChange = (e) => {
        onInstructionsChange(e.target.value);
        setInstructions(e.target.value);
    }

    const getEmailSplitedData = () => {
        

        let data = email.trim().split(";").join("\n")
        data = data.replace(/^\s*\n/gm, "") 
        return <div className="attendee-email-view">{data}</div>
    }
    return (

        !readOnlyOptions ?
            <div className='invite-form'>
            {<h4 className='page-subtitle'>Invite Attendees</h4>}
                <div className="invite-form-boxs">
                    <TextField
                        margin="normal"
                        id="name"
                        label="Attendee(s) email separated by semicolon*"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => { setEmails(e.target.value); setError('') }}
                        value={email}
                        error={!!error}
                        helperText={error}
                        disabled={!!readOnlyOptions}
                        multiline
                        rows="1"
                        rowsMax={5}
                       
                    />
                   
                    <TextField
                        id="outlined-multiline-static"
                        label="Event Description"
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        value={instructions}
                        onChange={handleInstructionsChange}
                        multiline
                        rowsMax="4"
                        rows="4"
                        disabled={!!readOnlyOptions && !isUpdateMode}
                    />
                    <TextField
                        id="outlined-multiline-static"
                        label="Event Location"
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        value={eventlocation}
                        onChange={(e) => { setEventlocation(e.target.value); }}
                        disabled={!!readOnlyOptions && !isUpdateMode}
                    />
                    {
                        //addressFieldsRenderer()
                    }

                </div>
            {!readOnlyOptions && (additionalFieldsRenderer())}

            {!readOnlyOptions && (
                <div className='form-controls'>
                    {warningMessage && <InfoMessage logger title={warningMessage} />}
                        <SubmitButton disableError={getDisableError() || warningMessage} title='Send Invite' onClick={handleSubmit} />
                    </div>
                )}

                {isEmptySeats && (
                    <div className="error-msg">You have not set the number of attendees. Please set your attendee count for each date, and then click Send Invite.</div>                    
                    )

                }
 
            </div>
            :
            <div className="invite-info-details">
                <div className="event-names-details">
                    <b>Event Name: {eventName}</b>
                </div>
                <div><b>Invitee(s): </b>{getEmailSplitedData()}</div>
                <div className="mt-10"><b> Event Information: </b><br />
                    {instructions}<br /><br />
                    {eventLocation && <span>Location: {eventLocation}</span>}
                </div>
            </div>

    );
}

export default InviteForm;